import { motion } from "framer-motion";

const RotatingIcon = ({ size, icon}) => {
  const MotionIcon = motion(icon);

  return (
    <MotionIcon size={size} animate={{ rotate: 360 }} transition={{repeat: Infinity, duration: 5, ease: "linear"}}/>
  );
};

export default RotatingIcon;
